var _path, _rect, _path2, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle4, _circle5, _path3, _defs, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 100C680 140 750 200 780 300C810 400 800 500 750 550C700 600 600 600 500 580C400 560 300 500 250 400C200 300 200 200 250 150C300 100 400 20 500 40C600 60 650 80 600 100Z",
    fill: "#E5EEFF",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 100,
    width: 500,
    height: 350,
    rx: 20,
    fill: "white",
    filter: "url(#shadow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 350L300 250L400 300L500 200L600 250",
    stroke: "#4299E1",
    strokeWidth: 3,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 250,
    r: 6,
    fill: "#4299E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 6,
    fill: "#4299E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 200,
    r: 6,
    fill: "#4299E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 280,
    width: 30,
    height: 70,
    rx: 4,
    fill: "#63B3ED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 260,
    width: 30,
    height: 90,
    rx: 4,
    fill: "#4299E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 240,
    width: 30,
    height: 110,
    rx: 4,
    fill: "#63B3ED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 220,
    width: 30,
    height: 130,
    rx: 4,
    fill: "#4299E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 150,
    width: 150,
    height: 80,
    rx: 10,
    fill: "#EBF8FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 250,
    width: 150,
    height: 80,
    rx: 10,
    fill: "#EBF8FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 80,
    r: 40,
    fill: "#BEE3F8",
    fillOpacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 450,
    r: 60,
    fill: "#90CDF4",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M700 200C720 220 730 250 720 280C710 310 690 320 670 310C650 300 640 280 650 260C660 240 680 230 700 200Z",
    fill: "#BEE3F8",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 0,
    y: 0,
    width: 800,
    height: 600,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.1
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 200,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "#2D3748"
  }, "$")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 180,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "#2D3748"
  }, "\u20AC")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 280,
    fontFamily: "Arial",
    fontSize: 20,
    fill: "#2D3748"
  }, "\xA3")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceHero);
export default __webpack_public_path__ + "static/media/finance_hero.a42016b3303c36552ceb27c22f2eab82.svg";
export { ForwardRef as ReactComponent };